/**
 * The pieces of an app's secret that look the same everywhere it is shown — Variables and secrets, and the app setup's
 * key step: a key as a chip (its connector icon, the Keybook page's, and its name), and the "Secret" badge.
 */
import { Lock } from 'lucide-react'
import { connectorIcon } from './key-icons.js'

export function KeyChip({ label, credentialType, title }: { label: string; credentialType?: string | null; title?: string }) {
  const Icon = connectorIcon({ credentialType: credentialType ?? '' })
  return (
    <span className="inline-flex items-center gap-1 min-w-0 max-w-full px-1.5 py-0.5 rounded themed-bg-tertiary themed-text-secondary" title={title}>
      <Icon size={11} className="shrink-0" />
      <span className="truncate">{label}</span>
    </span>
  )
}

export function SecretBadge({ label }: { label: string }) {
  return (
    <span className="inline-flex items-center gap-1 text-[10px] font-medium uppercase tracking-wide px-1.5 py-0.5 rounded themed-bg-tertiary themed-chip-secret shrink-0">
      <Lock size={10} />{label}
    </span>
  )
}
